<template>
	<div>
		<div class="login_title">开票登录</div>
		<van-cell-group>
			<van-field
				center
				clearable
				v-model="form.phone"
				type="tel"
				label="手机号"
				placeholder="手机号"
			/>
			<van-field
				center
				clearable
				type="digit"
				v-model="form.verificationCode"
				label="验证码"
				placeholder="短信验证码"
			>
				<template #button>
					<span v-if="sending" @click="getCode" style="color: #1989fa;">发送验证码</span>
					<span class="c_999" v-else>{{second}}s后重新获取</span>
				</template>
			</van-field>
		</van-cell-group>
		<div style=" padding: 32px 16px 0 16px;">
		    <van-button round block type="info" :disabled="loginLoading" :loading="loginLoading" @click="login">登 录</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Login',
		data() {
			return {
				form : {
					phone : '',
					verificationCode : ''
				},
				sending: true,//是否发送验证码
				second:60,//倒计时间
				loginLoading : false
			}
		},
		mounted(){
		},
		methods: {
			getCode(){
				var phone = this.form.phone;
				if( !phone ){
					this.$toast('请输入手机号码');
					return false;
				}
				if (!(/^1[3456789]\d{9}$/.test(phone))) {
				  this.$toast('手机号格式错误');
				  return false;
				}
				this.$toast.loading({
					message: '请求中...',
					forbidClick: true,
					duration : 0
				});
				if( this.sending ){
					this.$post('/gtb/sendVerificationCode.html', { phone : phone }).then(res=>{
						this.$toast.clear();
					    if( res.success ){
					        this.$toast.success(res.msg);
					        this.timeDown();
							this.sending = false;
					    }else{
							this.$dialog({
								title : '提示',
								message: res.msg,
							});
					    };
					}).catch((res) => {
						this.$toast.clear();
					});
				}
			},
			login(){
				if( !this.form.phone ){
					this.$toast('请输入手机号码');
					return false;
				}
				if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
				  this.$toast('手机号格式错误');
				  return false;
				}
				if( !this.form.verificationCode ){
					this.$toast('请输验证码');
					return false;
				}
				
				this.loginLoading = true;
				this.$post('/gtb/h5login.html', this.form ).then(res=>{
					this.loginLoading = false;
					if( res.success ){
						this.$toast.success(res.msg);
						localStorage.setItem('sid', res.sid);
						this.$router.push('/index');
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch((res) => {
					this.loginLoading = false;
				});
				
			},
			timeDown: function() {
				let result = setInterval( ()=>{
			        this.second--;
			        if(this.second < 1){
						clearInterval(result);
						this.sending = true;
						this.second = 60;
			        }                   
			    }, 1000);
			}
		},
	}
</script>
<style scoped>
.login_title{ padding: 32px 16px;font-weight: bold; font-size: 18px;}
</style>
